import { render } from "./kalio-startup-application-references.vue?vue&type=template&id=52b144e9"
import script from "./kalio-startup-application-references.vue?vue&type=script&lang=js"
export * from "./kalio-startup-application-references.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__